<template>
  <div class="tableData">
    <div class="assetFieldDiv">
      <div class="topTitle">
        <div class="title">
          <span>资产基础信息字段</span>
        </div>
      </div>
      <div class="btnGroup" v-if="$auth('assetHeadManage.save')">
        <a-button type="primary" @click="whetherToSelectAll(true)" :loading="saveLoading" class="checkAll">全选</a-button>
        <a-button @click="whetherToSelectAll(false)" :loading="saveLoading" class="deselectAll">取消全选</a-button>
        <a-button type="primary" @click="save" :loading="saveLoading" class="saveBtn">保存</a-button>
      </div>
      <div style="height: calc(100% - 90px);overflow-y:auto;">
        <a-checkbox-group v-model="checkedList" :options="plainOptions" @change="onChange" />
      </div>
    </div>
    <div class="treeListDiv">
      <div class="titleDiv">
        <div class="title">
          <span>已选资产字段</span>
        </div>
      </div>
      <a-spin :spinning="treeLoading">
        <a-tree
          :draggable="$auth('assetHeadManage.drop')"
          :treeData="treeData"
          @dragstart="onStart"
          @drop="onDrop"
          :selectedKeys="selectedKeys"
        >
          <template slot="custom" slot-scope="item">
            <span>{{ item.title }}</span>
          </template>
        </a-tree>
      </a-spin>
    </div>
  </div>
</template>

<script>
import { dragMenuInfo, getMenuInfo } from '@/api/menu'
import { getAssetField, getAssetTypeField, saveAssetTypeField } from '@/api/assetHeadManage'
import { mapGetters } from 'vuex'

export default {
  name: 'TableData',
  computed: {
    ...mapGetters(['assetTypeCode'])
  },
  data () {
    return {
      // 树
      treeData: [],
      // 树搜索
      searchValue: '',
      // 树当前选中节点
      selectedKeys: [],
      // 树loading
      treeLoading: false,
      // 多选列表
      plainOptions: [],
      // 多选
      checkedList: [],
      indeterminate: true,
      checkAll: false,
      // 保存loading
      saveLoading: false
    }
  },
  created () {
    this.getAllAssetField()
  },
  mounted () {
  },
  watch: {
    assetTypeCode (newValue) {
      this.getTreeList()
    }
  },
  methods: {
    // 获取树形菜单
    async getTreeList () {
      const query = {
        typeCode: this.assetTypeCode.typeCode,
        type: 1
      }
      this.checkedList = []
      this.treeLoading = true
      getAssetTypeField(query).then(res => {
        if (res.status === 0) {
          res.data.forEach(item => {
            item.scopedSlots = { title: 'custom' }
            item.key = item.dataIndex
            this.checkedList.push(item.dataIndex)
          })
          this.treeData = res.data
          this.indeterminate = !!this.checkedList.length && this.checkedList.length < this.plainOptions.length
          this.checkAll = this.checkedList.length === this.plainOptions.length
          this.treeLoading = false
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取所有资产字段
    getAllAssetField () {
      const data = {
        pCode: 'asset_field'
      }
      getAssetField(data).then(res => {
        if (res.status === 0) {
          this.plainOptions = res.data.map(item => {
            return {
              label: item.name,
              value: item.code
            }
          })
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    },
    // 多选回调
    onChange (checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    // 是否全选
    whetherToSelectAll (bool) {
      Object.assign(this, {
        checkedList: bool ? this.plainOptions.map(item => { return item.value }) : []
      })
    },
    // 拖拽
    onDrop (info) {
      let realPos
      let that = this;
      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr)
          }
          if (item.children) {
            return loop(item.children, key, callback)
          }
        })
      }
      const data = [...this.treeData]
      const dragPos = info.dragNode.pos.split('-')
      // 判断是否在同一个父节点下移动
      if (dragPos.length === dropPos.length && dragPos[dragPos.length - 2] === dropPos[dropPos.length - 2]) {
        if (dropPosition === -1) {
          realPos = Number(dropPos[dropPos.length - 1]) + 1
        } else {
          realPos = Number(dropPos[dropPos.length - 1]) + 2
        }
        if (Number(dragPos[dragPos.length - 1]) < Number(dropPos[dropPos.length - 1])) {
          realPos = realPos - 1
        }
      } else {
        if (dropPosition === -1) {
          realPos = info.dropPosition + 2
        } else {
          realPos = info.dropPosition + 1
        }
      }
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1)
        dragObj = item
      })
      if (info.dropToGap) {
        let ar
        let i
        loop(data, dropKey, (item, index, arr) => {
          ar = arr
          i = index
        })
        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj)
        } else {
          ar.splice(i + 1, 0, dragObj)
        }
        let showTitle = ''
        showTitle = `您确定调整【${info.dragNode.dataRef.title}】的顺序为第【${realPos}】位吗?`
        this.$confirm({
          title: showTitle,
          onOk () {
            // this.treeData = data
            that.drop(data)
          },
          onCancel () {}
        })
      }
    },
    // 开始拖拽
    onStart (info) {
      this.dragSort = info.node.dataRef.sort
      this.dragId = info.node.dataRef.id
    },
    // 菜单拖拽
    async drop (data) {
      const params = {
        typeCode: this.assetTypeCode.typeCode,
        dataIndexList: data.map(item => {
          return item.dataIndex
        }),
        type: 1
      }
      saveAssetTypeField(params).then(res => {
        if (res.status === 0) {
          this.$message.success('操作成功!')
          this.getTreeList()
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    },
    // 保存设置
    save () {
      const data = {
        typeCode: this.assetTypeCode.typeCode,
        dataIndexList: this.checkedList,
        type: 1
      }
      this.saveLoading = true
      saveAssetTypeField(data).then(res => {
        if (res.status === 0) {
          this.saveLoading = false
          this.getTreeList()
          this.$message.success(res.info.message)
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    }
  }
}
</script>

<style scoped lang="less">
.tableData {
  height: 100%;
  width: 100%;
  display: flex;
}
.treeListDiv {
  width: 300px;
  height: 100%;
  padding: 16px 12px;
}
.assetFieldDiv {
  width: calc(100% - 300px);
  padding-right: 12px;
  border-right: 1px solid #DDDDDD;
}
.topTitle {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title span{
    font-weight: bold;
  }
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title span{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    font-weight: bold;
  }
}
.btnGroup {
  display: flex;
  padding: 11px 0;
  border-top: 1px solid #DDDDDD;
  .checkAll {
  }
  .deselectAll {
    margin-left: 8px;
  }
  .saveBtn {
    margin-left: auto;
  }
}
/deep/ .ant-spin-nested-loading {
  height: calc(100% - 40px);
  .ant-spin-container {
    height: 100%;
    .ant-tree {
      height: 100%;
    }
  }
}
/deep/.ant-tree li .ant-tree-node-content-wrapper {
  width: calc(100% - 24px);
  height: 100%;
}
/deep/.ant-tree li .ant-tree-node-content-wrapper .ant-tree-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
/deep/.ant-checkbox-group-item {
  width: calc(100% / 4);
  margin: 0 0 10px 0 !important;
}
</style>
